import React, { useState } from 'react';
import { Transition } from '@headlessui/react';
import CaretDownSolid from '@/components/commons/icons/CaretDownSolid';
import styles from '@/components/commons/loader/Loader.module.css';

function Answer({
    questionInfo, saveQuestionData, currentlySending,
}) {
    const [isOpen, setIsOpen] = useState(false);

    const defineOption = () => {
        if (typeof questionInfo.answer === 'number') {
            return questionInfo.question.buttons[questionInfo.answer].label;
        }
        if (questionInfo.answer) {
            return questionInfo.question.buttons[0].label;
        }
        return questionInfo.question.buttons[1].label;
    };

    return (
        <div key={questionInfo.question.id} className="w-full flex items-center justify-between bg-cirrusWhite rounded-lg py-2 my-2">
            <div className="flex items-center mr-2">
                {questionInfo.question.contactCard ? (
                    <div className="mr-8 ml-2 flex relative">
                        <div className="width-[30px]">
                            {questionInfo.question.contactCard.reviewAvatar}
                        </div>
                        <div className="absolute left-[16px]">
                            {questionInfo.question.contacts[0].reviewAvatar}
                        </div>
                    </div>
                ) : (
                    <div className="mr-4 ml-2 width-[30px]">
                        {questionInfo.question.contacts[0].reviewAvatar}
                    </div>
                )}
                <p className="text-[14px]">{questionInfo.question.reviewSubtitle}</p>
            </div>
            <div
                data-tooltip-id="tip"
                title="Actions"
                aria-label="Actions"
                role="button"
                tabIndex={0}
                onClick={() => setIsOpen(!isOpen)}
                onKeyDown={(e) => {
                    if (e.key === ' ' || e.key === 'Enter') {
                        e.preventDefault();
                        setIsOpen(!isOpen);
                    }
                }}
                className="relative border-[1px] border-green-400 bg-green-400 rounded-xl flex items-center justify-end mr-2 "
            >
                <Transition
                    show={isOpen}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                >
                    <div
                        className="z-[10000] flex flex-col items-start justify-start rounded-lg absolute w-full top-[40px] bg-cleanSlate space-y-3 px-4 shadow-lg"
                    >
                        {questionInfo.question.buttons.map((button, index) => (
                            <button
                                type="button"
                                data-tooltip-id="tip"
                                key={`question-${questionInfo.question.id}-${button.value}`}
                                title={button.label}
                                aria-label={button.label}
                                onClick={() => saveQuestionData(
                                    button.value,
                                    questionInfo.question,
                                )}
                                className={`w-full pb-3 ${index !== questionInfo.question.buttons.length - 1 ? 'border-b-2 border-lightGray' : ''} ${index === 0 ? 'pt-3' : ''}`}
                            >
                                <p className="text-cirrusWhite text-[12px] text-left">{button.label}</p>
                            </button>
                        ))}

                    </div>
                </Transition>
                <div className="relative border-[1px] border-green-400 bg-green-400 rounded-lg flex items-center justify-center px-2 py-2">
                    {currentlySending === questionInfo.question.id
                        && <div className={`${styles.loader} ease-linear rounded-full border-4 h-5 w-5 mr-2`} />}
                    <p className="text-cirrusWhite text-[12px] mr-2">{defineOption()}</p>
                    <CaretDownSolid className="h-4 w-4 text-white" />
                </div>
            </div>
        </div>
    );
}

export default Answer;
